import request from './adminRequest'

const autoApplyStatsApi = {
  getSuccessRate (params) {
    return request.get('/autoApply/successRate', { params })
  },
  getFilterOptions () {
    return request.get('/autoApply/filterOptions')
  },
  getUserDailyStats (params) {
    return request.get('/autoApply/userDailyStats', { params })
  },
}

export default autoApplyStatsApi
